<template>
    <rkm-modal
        :buttons="['cancel']"
        ref="RkmModal"
        title="Agenda do dia"
    >
        <rkm-alert show info>
            <strong>{{dia}} - {{ getStringDiaSemana(semanaId) }}</strong>
        </rkm-alert>

        <rkm-table
            :fields="fields.tables.diaSelecionado"
            :items="items"
            sort-by="horaInicial"
            hide-filters
            hide-pagination
            hover
            striped
        >
            <template v-slot:cell(actions)="{ item, index }">
                <rkm-button
                    color="primary"
                    title="Editar"
                    small
                    @click="edit(item, index)"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>
            </template>
        </rkm-table>
    </rkm-modal>
</template>

<script>

// Mixins.
import { error, repository } from '@/mixins'

export default {
        computed: {
        fields() {
            return {
                tables: {
                    diaSelecionado: [
                        { key: 'horaInicial', label: 'Inicio', sortable: true },
                        { key: 'horaFim', label: 'Fim', sortable: true },
                        { key: 'vagas', label: 'Vagas', sortable: true },
                        { key: 'tempoAtendimento', label: 'Tempo(min)', sortable: true },
                        { key: 'tipoNome', label: 'Tipo', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' }
                    ],
                },
            }
        },
    },
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('exameImagem.jornada')
        }
    },
    data: () => ({
        items: [],
        dia: null,
        semanaId: null,
    }),
    methods: {
        open(item, diaSelecionado, diaTratado, semanaId) {

            this.item = item

            this.items = diaSelecionado

            this.dia = diaTratado

            this.semanaId = semanaId

            this.$refs.RkmModal.show()
        },
        edit(item, index) {
            this.$emit('handleAlter', item, index)
            this.$refs.RkmModal.hide()
        },
        getStringDiaSemana(dia) {

            if(dia == '1'){
               return 'DOMINGO'

            } else if (dia == '2'){
               return 'SEGUNDA-FEIRA'

            } else if (dia == '3'){
               return 'TERÇA-FEIRA'

            } else if (dia == '4'){
               return 'QUARTA-FEIRA'

            } else if (dia == '5'){
               return 'QUINTA-FEIRA'

            } else if (dia == '6'){
               return 'SEXTA-FEIRA'

            } else if (dia == '7'){
               return 'SÁBADO'
            }
        },
    },
      props: {
        model: { type: Object, required: true },
    },
    mixins: [ error, repository ],
}
</script>